import { render, staticRenderFns } from "./wel.vue?vue&type=template&id=6af7aa98&"
import script from "./wel.vue?vue&type=script&lang=js&"
export * from "./wel.vue?vue&type=script&lang=js&"
import style0 from "./wel.vue?vue&type=style&index=0&id=6af7aa98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports